<div class="wrapper">
  <div class="heading text-type-2 mb-[40px]">
    {{ data?.source?.name || data?.source?.first_name && (data?.source?.first_name + ' ' + data?.source?.last_name) || 'Edit labor' }}
  </div>
  <form>
    <app-dropdown
      (checkForErrors)="checkForErrors($event)"
      [enableSearch]="subContractorOptions.length >= 10"
      [error]="errorMessages['sub_contractor']"
      [options]="subContractorOptions"
      [parentFormGroup]="form"
      class="mb-[20px]"
      controlName="sub_contractor"
      label="Contractor"
    />
    @if (data?.source_type === 'genericPersonnel') {
      <div class="flex flex-row gap-[20px] w-full mb-[20px]">
        <app-number-input
          [parentFormGroup]="form"
          class="w-1/2"
          controlName="quantity"
          label="Quantity"
        />
        <app-number-input
          [parentFormGroup]="form"
          class="w-1/2"
          controlName="hours"
          [isDecimalAllowed]="true"
          label="Hours"
        />
      </div>
    }
    @if (data?.source_type === 'employees') {
      <app-number-input
        [parentFormGroup]="form"
        class="mb-[20px]"
        controlName="hours"
        [isDecimalAllowed]="true"
        label="Hours"
      />
    }
    <app-text-area
      [parentFormGroup]="form"
      class="mb-[20px]"
      controlName="comment"
      label="Comment"
    />
  </form>
</div>
